<template>
  <div>
    <div class="dialog-footer">
      <el-button size="mini" type="primary" @click="submitForm('form')">保存</el-button>
    </div>
    <div style="max-height: 700px;overflow-y: auto;">
      <el-descriptions class="margin-top" title="" :column="2" size="mini" border :label-style="{width: '100px'}" :content-style="{width: 'calc(50% - 100px)'}">
        <el-descriptions-item label="仪表编号">
          <!--            <div style="display: flex;"><el-input size="mini" class="form-input" v-model="form.number" autocomplete="off"></el-input><span style="color: red;margin-top: 5px;">*</span></div>-->
          <el-row>
            <el-col :span="16">
              <el-input size="mini" class="form-input" v-model="form.number" clearable autocomplete="off" data-intro="这里输入仪表编号，仪表编号必须唯一" data-position="top"></el-input>
            </el-col>
            <el-col :span="8">
              <el-button v-if="!form.id" size="mini" @click="getMeterNumber">获取</el-button><span style="color: red;margin-top: 5px;">*</span>
            </el-col>
          </el-row>
        </el-descriptions-item>
        <el-descriptions-item label="所在房产">
          <el-row>
            <el-col :span="16">
              <el-input size="mini" class="form-input" v-model="form.house_name" clearable autocomplete="off"></el-input>
            </el-col>
            <el-col :span="8">
              <el-button size="mini" @click="shoeTreeDialogVisible">选择</el-button><span style="color: red;margin-top: 5px;">*</span>
            </el-col>
          </el-row>
        </el-descriptions-item>
        <el-descriptions-item label="仪表名称">
          <el-input size="mini" class="form-input" v-model="form.name" autocomplete="off"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="上级仪表">
          <el-autocomplete
            data-intro="这里输入上级仪表名称/仪表编号,输入后系统提示了请点击上级仪表"
            data-position="top"
            style="min-width: 400px;max-width: 100%"
            v-model="form.p_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            @clear="form.upid=''"
            placeholder="请输入仪表名称/仪表编号"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
          {{form.parent_number}}
        </el-descriptions-item>
        <el-descriptions-item label="代理表">
<!--          <el-input size="mini" class="form-input" v-model="form.sync_meter_id" autocomplete="off"></el-input>-->
          <el-autocomplete
            data-intro="这里输入上级仪表名称/仪表编号,输入后系统提示了请点击上级仪表"
            data-position="top"
            style="min-width: 400px;max-width: 100%"
            v-model="sync_meter_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="form.sync_meter_id=$event.id"
            @clear="form.sync_meter_id=''"
            placeholder="请输入仪表名称/仪表编号"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
          &nbsp;&nbsp;
          {{form.sync_meter_id}}
          &nbsp;&nbsp;
          <el-link type="danger" v-if="form.sync_meter_id" @click="form.sync_meter_id=''">清空</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="代理内容">
          <el-select size="mini" v-if="form.sync_meter_id" v-model="form.sync_meter_compute_type">
            <el-option label="用量" :value="1"></el-option>
            <el-option label="金额" :value="2"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="倍率">
          <div style="display: flex;"><el-input size="mini" class="form-input" v-model="form.magnification" autocomplete="off"></el-input><span style="color: red;margin-top: 5px;">*</span></div>
        </el-descriptions-item>
        <el-descriptions-item label="仪表等级">
          <div style="display: flex;">
            <el-select size="mini" style="width: 100%" v-model="form.meter_level" filterable placeholder="仪表等级" class="kuan">
              <el-option v-for="item in meter_level_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
            <span style="color: red;margin-top: 5px;">*</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="仪表状态">
          <el-radio v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :key="item.val" v-model="form.status" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="仪表性质">
          <el-radio v-for="item in meter_nature_list"
                    :key="item.val" v-model="form.meter_nature" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <!-- 不是分摊表 -->
        <el-descriptions-item label="能耗类型">
          <el-radio v-for="(item,index) in energy_list" :key="index" v-model="form.energy" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="虚表类型">
          <el-radio v-for="item in [{name:'实表',val:1},{name:'虚表',val:2}]" :key="item.val" v-model="form.meter_virtually" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
<!--        <el-descriptions-item label="固定金额" v-if="form.meter_virtually==3">-->
<!--          <el-input size="mini" class="form-input" v-model="form.fixed_amount" autocomplete="off" placeholder="请输入固定金额"></el-input>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="仪表户号" v-if="form.meter_virtually==1">
          <el-input size="mini" class="form-input" v-model="form.house_number" autocomplete="off"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="初始读数" v-if="form.meter_virtually==1">
          <div style="display: flex;"><el-input size="mini" class="form-input" v-model="form.start_number" autocomplete="off"></el-input><span style="color: red;margin-top: 5px;">*</span></div>
        </el-descriptions-item>
        <el-descriptions-item label="仪表表号" v-if="form.meter_virtually==1">
          <el-input size="mini" class="form-input" v-model="form.meter_number" autocomplete="off"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="回程" v-if="form.meter_virtually==1">
          <el-input size="mini" class="form-input" v-model="form.return_trip" autocomplete="off"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <div style="display: flex;">
            <el-select size="mini" style="width: 100%" v-model="form.meter_type" filterable placeholder="仪表类型" class="kuan">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="color: red;margin-top: 5px;">*</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="安装日期" v-if="form.meter_virtually==1">
          <el-date-picker v-model="form.install_time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          <span style="color: red;margin-top: 5px;">*</span>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <div style="display: flex;">
            <el-select size="mini" style="width: 100%" v-model="form.charging_standard" filterable clearable placeholder="收费标准" class="kuan">
              <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="color: red;margin-top: 5px;">*</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="上次抄表时间" v-if="form.meter_virtually==1">
          <el-date-picker v-model="form.reading_time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="仪表排序" v-if="form.meter_virtually==1">
          <el-input size="mini" class="form-input" v-model="form.sort" autocomplete="off"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="位置" v-if="form.meter_virtually==1">
          <el-input size="mini" class="form-input" v-model="form.position" autocomplete="off"></el-input>
        </el-descriptions-item>

        <el-descriptions-item label="备注">
          <el-input type="textarea" placeholder="请输入内容" v-model="form.remarks" maxlength="100" show-word-limit></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="附件">
          <el-row>
            <el-col :span="12">
              <el-link type="primary" @click="$refs.ViewFileListRef.UploadFile(data=>{form.files=data.FileID},form.files)">上传附件</el-link>
            </el-col>
            <el-col :span="12">
              <el-link type="primary" v-if="form.files" @click="$refs.ViewFileListRef.show(form.files)">查看下载</el-link>
            </el-col>
          </el-row>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-dialog title="选择房产" z-index="991" :visible.sync="treeDialogVisible" :close-on-click-modal="false" width="300px">
      <div style="max-height: 400px;overflow-y: auto;">
        <erp-tree-status height="300px" @node-click="nodeClick2"></erp-tree-status>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="treeDialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <ViewFileList ref="ViewFileListRef" />
  </div>
</template>

<script>

import UploadFilesSysc from "../../../../App/Card/components/UploadFilesSysc";
import MeterTree from "./MeterTree";
import ErpTreeStatus from "../../../../Common/erp-tree-status";
import ViewFileList from "../../../../Common/ViewFileList";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterInfoEditor",
  components: {ViewFileList, ErpTreeStatus, MeterTree, UploadFilesSysc},
  inject:['mainObj','componentId','setComponentId','formData'],
  data(){
    return{
      treeDialogVisible:false,
      form: {
        pid:'',
        upid:'',
        p_name:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        meter_level:"",
        meter_virtually:1,
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energy:1,
        energy_nature:"1",
        fixed_amount:'',
        sync_meter_id:"",
        sub_meter_ids:[],
        sync_meter_compute_type:1,
      },
      meter_type_list:[],
      house_charge_list:[],
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      meter_level_list:[{name:'一级',val:1},{name:'二级',val:2},{name:'三级',val:3},{name:'四级',val:4},{name:'不设置',val:0}],
      formLoading:false,
      host_url:"",
      sync_meter_name:"",
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    that.getMeterTypeList()
    that.form=that.formData();
    if(!that.form.id){
      that.form.project_id = that.mainObj.project_id;
      that.form.house_name = that.mainObj.house_name;
      that.form.house_id = that.mainObj.house_id;
    }
    // setTimeout(()=>{
    //   that.$introJs(".margin-top").start();
    // },1000)
  },
  methods:{
    getMeterNumber(){
      const that=this;
      if(!that.form.project_id){
        that.$message.error('请选择项目')
        return false
      }
      if(!that.form.meter_type){
        that.$message.error('请选择仪表类型')
        return false
      }
      if(!that.form.energy){
        that.$message.error('请选择能耗类型')
        return false
      }
      MeterHttp.get("Meter/getMeterNumber?user_type="+(that.$route.query.type||0),{
        project_id:that.form.project_id,
        meter_type:that.form.meter_type,
        energy:that.form.energy
      },ret=>{
        if(ret.code){
          that.form.number=ret.data;
          that.$forceUpdate();
          that.$message.success('获取成功')
        }else {
          that.$message.error('获取失败')
        }
      })
    },
    shoeTreeDialogVisible() {
      this.treeDialogVisible = true;
    },
    querySearchAsyncRoom(queryString, cb){
      const that=this;
      if(!queryString){
        cb([]);
      }else {
        MeterHttp.post("Meter/getMeterKeyValue?user_type="+(that.$route.query.type||0),{
          keyWord:queryString,
          project_id:that.form.project_id,
        },ret=>{
          if(ret.code) {
            if(ret.data.length===1){
              that.form.upid=ret.data[0].id;
            }
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.form.upid=item.id;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_ids&&(where.chargeItem_name_ids=this.chargeItem_name_ids);
      MeterHttp.get("HouseCharge/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    getFormData(data) {
      return Object.assign({
        pid:'',
        upid:'',
        p_name:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energy:1,
        energy_nature:"1",
        fixed_amount:"",
        sync_meter_id:"",
        sub_meter_ids:[],
        sync_meter_compute_type:1,
      }, data)
    },
    submitForm() {
      const that = this;
      that.formLoading = true
      let data = Object.assign({}, this.form)
      let data_meter = {};

      let fields = [
        "id",
        "number",
        "cdj_house_id",
        "house_id",
        "pid",
        "children_count",
        "name",
        "project_id",
        "house_name",
        "house_number",
        "meter_number",
        "meter_type",
        "meter_level",
        "meter_virtually",
        "meter_tag",
        "charge_type",
        "charging_standard",
        "sort",
        "status",
        "meter_nature",
        "magnification",
        "start_number",
        "return_trip",
        "install_time",
        "reading_time",
        "position",
        "lat",
        "lng",
        "files",
        "qrcode",
        "line",
        "specifications",
        "remarks",
        "end_number",
        "end_use",
        "is_update",
        "weight",
        "meter_update_time",
        "admin_name",
        "admin_id",
        "create_time",
        "update_time",
        "task_id",
        "setup",
        "charge_rate",
        "other_sys_meter_id",
        "sub_meter_id",
        "xsc_id",
        "xsc_houseID",
        "xsc_precinctID",
        "xsc_meter_type",
        "xsc_charging_standard",
        "energys",
        "energy_nature",
        "energy",
        "energy_ext1",
        "level",
        "upid",
        "upids",
        "parent_number",
        "p_name",
        "check_statu",
        "fixed_amount",
        "is_power_supply_bureau",
        "amount_tag",
        "abbreviation",
        "sync_meter_id",
        "sync_meter_compute_type",
        "sub_meter_ids"
      ];

      fields.forEach(field => {
        if (data[field] !== undefined) {
          data_meter[field] = data[field];
        }
      })

      if(!data_meter.meter_nature){
        that.$message.error('请选择仪表性质');
        return false;
      }
      MeterHttp.post("Meter/save?user_type="+(that.$route.query.type||0),data_meter,res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.dialogVisible = false
        }
        that.formLoading = false
      })
    },
    nodeClick2(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      //console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
    },
  },
  watch:{
    "form.project_id":function (n) {
      this.getHouseChargeList();
    },
    "form.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.form.project_id = that.mainObj.project_id;
      this.form.house_name = n;
      this.form.house_id = that.mainObj.house_id;
      this.where.house_name=n;
    },
    formData:{
      // immediate:true,
      deep:true,
      handler(n){
        console.log("formData==>",n)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterInfoEditor.vue